export enum ASK_AI_CONVERSATION {
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=686565072
     */
    YOU_STOPPED_THIS_RESPONSE = 'ASK_AI_CONVERSATION.YOU_STOPPED_THIS_RESPONSE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=686620152
     */
    STOP_STREAMING = 'ASK_AI_CONVERSATION.STOP_STREAMING',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=697919526
     */
    MATCHING_RULES = 'ASK_AI_CONVERSATION.MATCHING_RULES',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=697919531
     */
    SEARCHING_SOURCES = 'ASK_AI_CONVERSATION.SEARCHING_SOURCES',
}
